if (document.querySelector('.summary-div')) {
    let previousCheckbox;
    let summaryDiv = document.querySelector('.summary-div');
    let attachmentsDiv = '';
    if (document.querySelector('.attachments-div')) {
        attachmentsDiv = document.querySelector('.attachments-div');
    }

    let htmlToAdd = `
            <div class="summary-div d-block d-md-flex ps-3 ps-md-0 pe-3 pe-md-0" data-initial-constraints="" data-template="default">
                <div class=" col-12  col-md-3">
                    <div class="summary-col-data base-data me-md-2 mb-2 mb-md-0">
                        <div class="summary-col-title">Dane podstawowe</div>
                        <div class="summary-data">
                            <div class="summary-title">Imię i nazwisko:</div>
                            <div class="summary-nameSurname"></div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-title">Pesel:</div>
                            <div class="summary-pesel"></div>
                        </div>
                        <div class="summary-data d-none">
                            <div class="summary-title">Dokument tożsamości:</div>
                            <div class="summary-idType"></div>
                        </div>
                        <div class="summary-data d-none">
                            <div class="summary-title">Data urodzenia:</div>
                            <div class="summary-birthDate"></div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-title">Adres podstawowy:</div>
                            <div class="d-flex">
                                <div class="summary-street me-1"></div>
                                <div class="summary-houseNumber me-1"></div>
                                <div class="summary-flatNumber me-1"></div>
                            </div>
                            <div class="d-flex">
                                <div class="summary-zipCode me-1"></div>
                                <div class="summary-city me-1"></div>
                            </div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-title">Adres do korespondencji:</div>
                            <div class="d-flex">
                                <div class="summary-streetC me-1"></div>
                                <div class="summary-houseNumberC me-1"></div>
                                <div class="summary-flatNumberC me-1"></div>
                            </div>
                            <div class="d-flex">
                                <div class="summary-zipCodeC me-1"></div>
                                <div class="summary-cityC me-1"></div>
                            </div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-title">Numer telefonu:</div>
                            <div class="summary-phone"></div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-title">Adres email:</div>
                            <div class="summary-email"></div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="summary-col-data contract-data me-md-2 mb-2 mb-md-0">
                        <div class="summary-col-title">Umowa o świadczenie usługi kompleksowej dla energii elektrycznej</div>
                        <div class="summary-data">
                            <div class="summary-title">Wybrana oferta:</div>
                            <div class="summary-nameOffer"></div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-title">Czas obowiązywania oferty:</div>
                            <div class="summary-timeOffer"></div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-electricityPrices"></div>
                        </div>
                        <div class="summary-data">
                           
                            <div class="summary-tariffElectricityForCustomers"></div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-tariffElectricityDistributionServices"></div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-title">Sprzedawca energii elektrycznej:</div>
                            <div class="summary-electricitySeller"></div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3">
                    <div class="summary-col-data energy-data ">
                        <div class="summary-col-title">Punkt poboru</div>
                        <div class="summary-data">
                            <div class="summary-title">Adres punktu poboru:</div>
                            <div class="d-flex">
                                <div class="summary-streetD me-1"></div>
                                <div class="summary-houseNumberD me-1"></div>
                                <div class="summary-flatNumberD me-1"></div>
                            </div>
                            <div class="d-flex">
                                <div class="summary-zipCodeD me-1"></div>
                                <div class="summary-cityD me-1"></div>
                            </div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-title">Numer PPE:</div>
                            <div class="summary-ppeNumber"></div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-title">Numer licznika:</div>
                            <div class="summary-energyConsumptionPoint"></div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-title">Grupa taryfowa:</div>
                            <div class="summary-tariffGroup"></div>
                        </div>
                        <div class="summary-data">
                            <div class="summary-title">E-faktura:</div>
                            <div class="summary-invoice"></div>
                        </div>
                    </div>
                </div>
            </div>
        `;

    summaryDiv.innerHTML = htmlToAdd;
    let summaryList = document.querySelectorAll('.summary');
    let summaryRadioList = document.querySelectorAll('.summary-radio');


    summaryList.forEach(input => {
        if (input.nodeName !== 'INPUT') {
            let listInput = Array.from(input.querySelectorAll('input'));
            listInput.forEach(el => {
                el.addEventListener('change', () => {
                    changeValue(el, summaryDiv);
                });
            })

            if (input.nodeName === 'SELECT') {
                input.addEventListener("change", function () {
                    changeValue(input, summaryDiv);
                });
            }
        } else {
            input.addEventListener('change', () => {

                if (input.type !== 'checkbox') {
                    changeValue(input, summaryDiv);
                    summaryList.forEach(function (input) {
                        if (input.getAttribute("name")) {
                            changeValue(input, summaryDiv);
                        }
                    });
                } else {
                    if (input.getAttribute('offerId') && input.checked) {

                        if (previousCheckbox && previousCheckbox !== input) {
                            previousCheckbox.checked = false;
                        }
                        previousCheckbox = input;

                        connectObjectFetch(input.getAttribute('offerId'))
                            .then(data => {
                                handleData(data, summaryDiv, attachmentsDiv)
                            })
                            .catch(error => {
                                console.error('Wystąpił błąd podczas pobierania danych:', error);
                            });

                    }
                }

            });
        }
        checkPesel();

    });

    summaryRadioList.forEach(function (el) {
        let inputRadioList = el.querySelectorAll('input');
        inputRadioList.forEach(function (radio) {
            radio.addEventListener("change", function () {
                summaryList.forEach(function (input) {
                    if (input.getAttribute("name")) {
                        changeValue(input, summaryDiv);
                    }
                });
            });
        });

    });

}

function changeValue(input, summaryDiv) {
    if (input.getAttribute("name")) {
        let fieldName = input.getAttribute("name");
        let startIndex = fieldName.indexOf("[") + 1;
        let endIndex = fieldName.lastIndexOf("]");
        let nameSurname = fieldName.substring(startIndex, endIndex);
        let summaryField = summaryDiv.querySelector(".summary-" + nameSurname);
        if (summaryField) {
            // summaryField.textContent = input.value;
            summaryField.innerHTML = input.value;
        }
    }
}

function connectObjectFetch(offerId) {
    let url = '/api/offerTable/' + offerId;
    return fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Błąd sieciowy - nie można pobrać danych z serwera.');
            }
            return response.json();
        })
        .then(data => {
            const kluczeIWartosci = {};
            const entries = Object.entries(data);
            entries.forEach(([key, value]) => {
                kluczeIWartosci[key] = value;

            });

            // console.log(kluczeIWartosci);
            return kluczeIWartosci;
        })
        .catch(error => {
            console.error('Wystąpił błąd podczas pobierania danych:', error);
            throw error;
        });
}

function handleData(data, summaryDiv, attachmentsDiv) {
    Object.keys(data).forEach(key => {
        if (!data[key]) {
            const summaryElement = document.querySelector(`.summary-${key}`);
            if (summaryElement) {
                summaryElement.parentElement.classList.add('d-none');
            }
        }
        if (key === 'attachmentsRelation') {
            if (attachmentsDiv) {
                attachmentsDiv.innerHTML = data[key];
            }
        } else {
            const summaryField = summaryDiv.querySelector(`.summary-${key}`);
            if (summaryField) {
                summaryField.innerHTML = data[key];
            }
        }
    });
}

function checkPesel(){
    if (document.querySelector('[disablefieldname="pesel"]')) {
        let checkboxPesel = document.querySelector('[disablefieldname="pesel"]');
        checkboxPesel.addEventListener("change", function () {
            if (checkboxPesel.checked) {
                document.querySelector('.summary-pesel').parentElement.classList.add('d-none');
                document.querySelector('.summary-idType').parentElement.classList.remove('d-none');
                document.querySelector('.summary-birthDate').parentElement.classList.remove('d-none');
            } else {
                document.querySelector('.summary-pesel').parentElement.classList.remove('d-none');
                document.querySelector('.summary-idType').parentElement.classList.add('d-none');
                document.querySelector('.summary-birthDate').parentElement.classList.add('d-none');
            }
        });
    }
}

function missedAddress() {
    const getSummaryElement = (className) => document.querySelector(`.summary-${className}`);
    const getFormValue = (inputName) => document.querySelector(`input[name="formbuilder_136[${inputName}]"]`).value;

    const elementNames = ['streetC', 'houseNumberC','flatNumberC','cityC','zipCodeC', 'flatNumberC','streetD', 'flatNumberD','houseNumberD', 'flatNumberD','cityD','zipCodeD'];
    const summaryElements = elementNames.map(getSummaryElement);

    elementNames.forEach((elementName, index) => {
        if (summaryElements[index].innerHTML.trim() === '') {
            summaryElements[index].innerHTML = getFormValue(elementName);
        }
    });
}

const allRadioButtons = document.querySelectorAll('[getvaluechoice]');

if (allRadioButtons) {
    allRadioButtons.forEach((radioButton) => {
        radioButton.addEventListener('change', missedAddress);
        //console.log(radioButton);
    });
}
